import { useEffect } from "react"

const useTitle =title =>{
    useEffect(()=>{
        document.title =`${title} - ALEXIS`
    },[title])
};

export default useTitle;